import client from 'lib/api/client';
import {TCutLists} from 'modules/cut';

/**
 * 웹 편집기
 * 영상 저장 API
 */

export interface ISetWebEditorJob {
  edit_job_info: TCutLists[][];
  edit_type: number;
  title_no: number;
  broad_no: number;
  info: IWebEditorContents;
  RESULT?: number;
  MSG?: string;
}

export interface IWebEditorContents {
  bbs: number;
  category: string;
  vod_category: string;
  title: string;
  contents: string;
  hotissue: string;
  strmLangType: string;
}

export async function setWebEditor(savePost: ISetWebEditorJob) {
  const {
    edit_job_info,
    edit_type,
    title_no,
    broad_no,
    info: {
      bbs: bbsNo,
      category,
      vod_category,
      title,
      contents,
      hotissue,
      strmLangType,
    },
  } = savePost;
  const form = new FormData();

  form.append('edit_job_info', JSON.stringify(edit_job_info));
  form.append('edit_type', JSON.stringify(edit_type));
  form.append('title_no', JSON.stringify(title_no));
  form.append('broad_no', JSON.stringify(broad_no));
  form.append('bbsNo', JSON.stringify(bbsNo));
  form.append('category', category);
  form.append('vod_category', vod_category);
  form.append('title', title);
  form.append('contents', contents);
  form.append('hotissue', hotissue);
  form.append('strmLangType', strmLangType);

  const response = await client.post<ISetWebEditorJob>(
    '/vodeditor/api/setWebEditorJob.php',
    form,
    {
      headers: {
        'content-type': 'multipart/form-data',
      },
    },
  );

  return response.data;
}
